import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
function processMindsetMeetingTranscript(_x) {
  return _processMindsetMeetingTranscript.apply(this, arguments);
}
function _processMindsetMeetingTranscript() {
  _processMindsetMeetingTranscript = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var s3FilePath, _yield$axios$get, summaryAnalysis, _error$response, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          s3FilePath = _ref.s3FilePath;
          _context.prev = 1;
          _context.next = 2;
          return axios.get('/api/mindset/transcript/process', {
            params: {
              s3FilePath: s3FilePath
            }
          });
        case 2:
          _yield$axios$get = _context.sent;
          summaryAnalysis = _yield$axios$get.data.summaryAnalysis;
          return _context.abrupt("return", summaryAnalysis);
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
          _t.formattedErrorMessage = ((_error$response = _t.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.error) || _t.message;
          throw _t;
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3]]);
  }));
  return _processMindsetMeetingTranscript.apply(this, arguments);
}
export default processMindsetMeetingTranscript;